import { render, staticRenderFns } from "./BasketPopover.vue?vue&type=template&id=39744a56"
import script from "./BasketPopover.vue?vue&type=script&lang=js"
export * from "./BasketPopover.vue?vue&type=script&lang=js"
import style0 from "./BasketPopover.vue?vue&type=style&index=0&id=39744a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports